/**
 * GENERAL
 */
export const GET_ADMIN_SETTINGS = 'GET_ADMIN_SETTINGS';
export const STORE_ADMIN_SETTINGS = 'STORE_ADMIN_SETTINGS';

/**
 * DASHBOARD -> charts info
 */
export const GET_CHARTS = 'GET_CHARTS';
export const GET_CHART = 'GET_CHART';
export const STORE_CHART = 'STORE_CHART';

/**
 * AUTH -> authentication
 */
export const INIT_LOADING = 'INIT_LOADING';
export const SHOW_APP_VIEWS = 'SHOW_APP_VIEWS';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const TEST_TOKEN = 'TEST_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const BOOTSTRAP_AUTH = 'BOOTSTRAP_AUTH';
export const SET_BOOTSTRAP_COMPLETE = 'SET_BOOTSTRAP_COMPLETE';
export const LOGIN_USER_FLAG = 'LOGIN_USER_FLAG';

/**
 * USERS -> users and profiles
 */
export const GET_PROFILE = 'GET_PROFILE';
export const STORE_TOKEN = 'STORE_TOKEN';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const GET_OPTIONS_FOR_SELECTS_PREFERENCES = 'GET_OPTIONS_FOR_SELECTS_PREFERENCES';
export const STORE_OPTIONS_FOR_SELECTS_PREFERENCES = 'STORE_OPTIONS_FOR_SELECTS_PREFERENCES';

export const GET_USER = 'GET_USER';
export const STORE_USER = 'STORE_USER';
export const STORE_TMP_USER = 'STORE_TMP_USER';
export const EDIT_USER = 'EDIT_USER';
export const SET_USER = 'SET_USER';
export const DELETE_USER = 'DELETE_USER';

export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const STORE_USERS = 'STORE_USERS';

export const GET_SUBACCOUNTS = 'GET_SUBACCOUNTS';
export const STORE_SUBACCOUNTS = 'STORE_SUBACCOUNTS';
export const STORE_ACTIVE_SUBACCOUNT = 'STORE_ACTIVE_SUBACCOUNT';

export const GET_MY_PERMISSIONS = 'GET_MY_PERMISSIONS';
export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS';
export const EDIT_USER_PERMISSIONS = 'EDIT_USER_PERMISSIONS';
export const STORE_USER_PERMISSIONS = 'STORE_USER_PERMISSIONS';

export const UPLOAD_USER_IMAGE = 'UPLOAD_USER_IMAGE';
export const REMOVE_USER_SIGNATURE = 'REMOVE_USER_SIGNATURE'

/**
 * SHOPS
 */
export const GET_SHOPS = 'GET_SHOPS';
export const SET_SHOP = 'SET_SHOP';
export const EDIT_SHOP = 'EDIT_SHOP';
export const STORE_SHOPS = 'STORE_SHOPS';

/**
 * SENDERS
 */
export const GET_SENDERS = 'GET_SENDERS';
export const SET_SENDER = 'SET_SENDER';
export const STORE_SENDERS = 'STORE_SENDERS';
export const EDIT_SENDER = 'EDIT_SENDER';
export const DELETE_SENDER = 'DELETE_SENDER';

/**
 * PAYERS
 */
export const GET_PAYERS = 'GET_PAYERS';
export const SET_PAYER = 'SET_PAYER';
export const STORE_PAYERS = 'STORE_PAYERS';
export const EDIT_PAYER = 'EDIT_PAYER';
export const DELETE_PAYER = 'DELETE_PAYER';

export const GET_PAYERS_OPTIONS = 'GET_PAYERS_OPTIONS'; // same as GET_PAYER but without permission

export const GET_PAYER_CARRIERS = 'GET_PAYER_CARRIERS';
export const STORE_PAYER_CARRIERS = 'STORE_PAYER_CARRIERS';
export const CLEAR_PAYER_CARRIERS = 'CLEAR_PAYER_CARRIERS';
export const CREATE_PAYER_CARRIER = 'CREATE_PAYER_CARRIER';
export const EDIT_PAYER_CARRIER = 'EDIT_PAYER_CARRIER';
export const DELETE_PAYER_CARRIERS = 'DELETE_PAYER_CARRIERS';

/**
 * PRINTERS
 */
export const GET_PRINTERS = 'GET_PRINTERS';
export const SET_PRINTER = 'SET_PRINTER';
export const STORE_PRINTERS = 'STORE_PRINTERS';
export const EDIT_PRINTER = 'EDIT_PRINTER';
export const TEST_PRINTER = 'TEST_PRINTER';
export const DELETE_PRINTER = 'DELETE_PRINTER';
export const GET_OPTIONS_FOR_WAYBILL_PRINTERS = 'GET_OPTIONS_FOR_WAYBILL_PRINTERS';
export const STORE_OPTIONS_FOR_WAYBILL_PRINTERS = 'STORE_OPTIONS_FOR_WAYBILL_PRINTERS';
/**
 * PACKAGES
 */
export const GET_PACKAGES = 'GET_PACKAGES';
export const SET_PACKAGE = 'SET_PACKAGE';
export const STORE_PACKAGES = 'STORE_PACKAGES';
export const EDIT_PACKAGE = 'EDIT_PACKAGE';
export const DELETE_PACKAGE = 'DELETE_PACKAGE';

/**
 * SMTP
 */
export const GET_SMTPS = 'GET_SMTPS';
export const SET_SMTP = 'SET_SMTP';
export const STORE_SMTP = 'STORE_SMTP';
export const EDIT_SMTP = 'EDIT_SMTP';
export const DELETE_SMTP = 'DELETE_SMTP';

export const GET_ALL_SMTPS = 'GET_ALL_SMTPS';
export const STORE_ALL_SMTPS = 'STORE_ALL_SMTPS';

/**
 * NEWS
 */
export const GET_NEWS = 'GET_NEWS';
export const GET_UNREAD_NEWS = 'GET_UNREAD_NEWS';
export const STORE_NEWS = 'STORE_NEWS';
export const MARK_NEWS_SEEN = 'MARK_NEWS_SEEN';
export const MARK_NEWS_ITEM_READ = 'MARK_NEWS_ITEM_READ';
export const CLEAR_NEWS = 'CLEAR_NEWS';

export const GET_WALL_NEWS = 'GET_WALL_NEWS';
export const STORE_WALL_NEWS = 'STORE_WALL_NEWS';

/**
 * SHIPMENTS
 */
export const GET_SHIPMENTS = 'GET_SHIPMENTS';
export const STORE_SHIPMENTS = 'STORE_SHIPMENTS';
export const RESET_STORE_SHIPMENTS = 'RESET_STORE_SHIPMENTS';
export const CLEAR_SHIPMENTS = 'CLEAR_SHIPMENTS';
export const GET_SHIPMENT = 'GET_SHIPMENT';
export const STORE_SHIPMENT = 'STORE_SHIPMENT';
export const CLEAR_SHIPMENT = 'CLEAR_SHIPMENT';
export const CREATE_COPY_SHIPMENT = 'CREATE_COPY_SHIPMENT';
export const CREATE_RETURN_SHIPMENT = 'CREATE_RETURN_SHIPMENT';
export const EMAIL_WAYBILLS = 'EMAIL_WAYBILLS';
export const UPLOAD_ADDITIONAL_FILE = 'UPLOAD_ADDITIONAL_FILE';
export const HOLD_SHIPMENT = 'HOLD_SHIPMENT';
export const UNHOLD_SHIPMENT = 'UNHOLD_SHIPMENT';
export const CANCEL_SHIPMENT = 'CANCEL_SHIPMENT';
export const GET_SHIPPERS = 'GET_SHIPPERS';
export const GET_BROKERS = 'GET_BROKERS';
export const GET_PICKUP_LOCATIONS = 'GET_PICKUP_LOCATIONS';
export const GET_PICKUP_ALLOWED_FREIGHT_PRODUCTS = 'GET_PICKUP_ALLOWED_FREIGHT_PRODUCTS';
export const STORE_SHIPPERS = 'STORE_SHIPPERS';
export const STORE_BROKERS = 'STORE_BROKERS';
export const STORE_PICKUP_LOCATIONS = 'STORE_PICKUP_LOCATIONS';
export const STORE_PICKUP_ALLOWED_FREIGHT_PRODUCTS = 'STORE_PICKUP_ALLOWED_FREIGHT_PRODUCTS';
export const GET_AVAILABLE_PRODUCTS = 'GET_AVAILABLE_PRODUCTS';
export const BOOK_SHIPMENT = 'BOOK_SHIPMENT';
export const SAVE_DRAFT = 'SAVE_DRAFT';
export const GET_LABEL = 'GET_LABEL';
export const PRINT_LABEL = 'PRINT_LABEL';
export const GET_PAYMENT_TERMS = 'GET_PAYMENT_TERMS';
export const GET_PALLET_EXCHANGE_SERVICE = 'GET_PALLET_EXCHANGE_SERVICE';
export const GET_ADDITIONAL_FILE_TYPES = 'GET_ADDITIONAL_FILE_TYPES'
export const STORE_ADDITIONAL_FILE_TYPES = 'STORE_ADDITIONAL_FILE_TYPES'
export const GET_TRACKING_LINK = 'GET_TRACKING_LINK';
export const GET_LABEL_IMAGE = 'GET_LABEL_IMAGE';
export const GET_CUSTOMS_DECLARABLE = 'GET_CUSTOMS_DECLARABLE';
export const GET_CUSTOMS_PDF = 'GET_CUSTOMS_PDF';
export const GET_ADDITIONAL_FILE = 'GET_ADDITIONAL_FILE';
export const GET_SHIPMENT_FILE = 'GET_SHIPMENT_FILE';
export const CREATE_EOD = 'CREATE_EOD';
export const GET_SHIPMENTS_EOD = 'GET_SHIPMENTS_EOD';
export const GET_ONE_EOD = 'GET_ONE_EOD';
export const STORE_SHIPMENTS_EOD = 'STORE_SHIPMENTS_EOD';
export const RESET_SHIPMENTS_EOD = 'RESET_SHIPMENTS_EOD';
export const STORE_SINGLE_EOD = 'STORE_SINGLE_EOD';
export const CLEAR_EOD_SINGLE = 'CLEAR_EOD_SINGLE';
export const PRINT_EOD = 'PRINT_EOD';
export const DOWNLOAD_EOD = 'DOWNLOAD_EOD';
export const REMOVE_SHIPMENT_EOD = 'REMOVE_SHIPMENT_EOD';
export const SET_EOD_SHIPMENTS = 'SET_EOD_SHIPMENTS'
export const CLEAR_SINGLE_EOD_SHIPMENTS = 'CLEAR_SINGLE_EOD_SHIPMENTS';

export const GET_SINGLE_EOD_SHIPMENTS = 'GET_SINGLE_EOD_SHIPMENTS';
export const STORE_SINGLE_EOD_SHIPMENTS = 'STORE_SINGLE_EOD_SHIPMENTS';

export const DOWNLOAD_MULTI_LABELS = 'DOWNLOAD_MULTI_LABELS';
export const GET_SCAN_IMAGE = 'GET_SCAN_IMAGE';
export const GET_POD = 'GET_POD';
export const GET_CMR = 'GET_CMR';
export const GET_DG_FILE = 'GET_DG_FILE';
export const EXPORT_CSV = 'EXPORT_CSV';

export const DATA_NOT_FOUND = 'DATA_NOT_FOUND';
export const GENERATE_NEW_INVOICE = 'GENERATE_NEW_INVOICE';
export const GENERATE_ACTION = 'GENERATE_ACTION';
export const RESET_DATA_NOT_FOUND = 'RESET_DATA_NOT_FOUND';

export const GET_BOOKING_SYSTEMS = 'GET_BOOKING_SYSTEMS';
export const STORE_BOOKING_SYSTEM = 'STORE_BOOKING_SYSTEM';
/**
 * DRAFT SHIPMENTS
 */
export const GET_DRAFT_SHIPMENTS = 'GET_DRAFT_SHIPMENTS';
export const STORE_DRAFT_SHIPMENTS = 'STORE_DRAFT_SHIPMENTS';
export const RESET_DRAFT_SHIPMENTS = 'RESET_DRAFT_SHIPMENTS';
export const CLEAR_DRAFT_SHIPMENTS = 'CLEAR_DRAFT_SHIPMENTS';
export const DELETE_DRAFTS = 'DELETE_DRAFTS';
export const REMOVE_DRAFT_FROM_LIST = 'REMOVE_DRAFT_FROM_LIST';
export const UPDATE_DRAFTS_COUNT = 'UPDATE_DRAFTS_COUNT';
export const REMOVE_DRAFTS_FROM_LIST = 'REMOVE_DRAFTS_FROM_LIST';

export const GET_SINGLE_DRAFT = 'GET_SINGLE_DRAFT';

export const SET_EDITING_SHIPMENT = 'SET_EDITING_SHIPMENT';
export const CLEAR_EDITING_SHIPMENT = 'CLEAR_EDITING_SHIPMENT';

export const PRINT_DRAFTS = 'PRINT_DRAFTS';

/**
 * UNAPPROVED SHIPMENTS
 */
export const GET_UNAPPROVED_SHIPMENTS = 'GET_UNAPPROVED_SHIPMENTS';
export const STORE_UNAPPROVED_SHIPMENTS = 'STORE_UNAPPROVED_SHIPMENTS';
export const RESET_UNAPPROVED_SHIPMENTS = 'RESET_UNAPPROVED_SHIPMENTS';
export const CLEAR_UNAPPROVED_SHIPMENTS = 'CLEAR_UNAPPROVED_SHIPMENTS';
export const DELETE_UNAPPROVEDS = 'DELETE_UNAPPROVEDS';

export const GET_SINGLE_UNAPPROVED = 'GET_SINGLE_UNAPPROVED';
export const PRINT_UNAPPROVEDS = 'PRINT_UNAPPROVEDS';
/**
 * SHARED SHIPMENTS
 */
export const GET_SHARED_SHIPMENTS = 'GET_SHARED_SHIPMENTS';
export const STORE_SHARED_SHIPMENTS = 'STORE_SHARED_SHIPMENTS';
export const RESET_SHARED_SHIPMENTS = 'RESET_SHARED_SHIPMENTS';
export const CLEAR_SHARED_SHIPMENTS = 'CLEAR_SHARED_SHIPMENTS';

/**
 * CONSOLIDATIONS
 */
export const GET_CONSOLIDATIONS = 'GET_CONSOLIDATIONS';
export const GET_CONSOLIDATION = 'GET_CONSOLIDATION';
export const CREATE_CONSOLIDATION = 'CREATE_CONSOLIDATION';
export const STORE_CONSOLIDATIONS = 'STORE_CONSOLIDATIONS';
export const RESET_CONSOLIDATIONS = 'RESET_CONSOLIDATIONS';
export const STORE_SINGLE_CONSOLIDATION = 'STORE_SINGLE_CONSOLIDATION';
export const CLEAR_SINGLE_CONSOLIDATION = 'CLEAR_SINGLE_CONSOLIDATION';
export const GET_CONSOLIDATION_SHIPMENTS = 'GET_CONSOLIDATION_SHIPMENTS';
export const STORE_CONSOLIDATION_SHIPMENTS = 'STORE_CONSOLIDATION_SHIPMENTS';
export const CLEAR_CONSOLIDATION_SHIPMENTS = 'CLEAR_CONSOLIDATION_SHIPMENTS';
export const GET_LAST_USED_WAYBILL_DATA = 'GET_LAST_USED_WAYBILL_DATA';

export const CREATE_WAYBILL_AND_ROUTING_LABEL = 'CREATE_WAYBILL_AND_ROUTING_LABEL';
export const EDIT_WAYBILL_AND_ROUTING_LABEL = 'EDIT_WAYBILL_AND_ROUTING_LABEL';
export const DOWNLOAD_CONSOLIDATION_WAYBILL = 'DOWNLOAD_CONSOLIDATION_WAYBILL';
export const COMPLETE_CONSOLIDATION_WAYBILL = 'COMPLETE_CONSOLIDATION_WAYBILL';

export const GET_CONSOLIDATION_CARRIER_ACCOUNTS = 'GET_CONSOLIDATION_CARRIER_ACCOUNTS';
export const GET_AVAILABLE_CONSOLIDATIONS = 'GET_AVAILABLE_CONSOLIDATIONS';
export const PRINT_CONSOLIDATION = 'PRINT_CONSOLIDATION';

export const REMOVE_SHIPMENTS_FROM_CONSOLIDATION = 'REMOVE_SHIPMENTS_FROM_CONSOLIDATION';

/**
 * PICKUPS
 */
export const GET_AVAILABLE_PICKUP_PRODUCTS = 'GET_AVAILABLE_PICKUP_PRODUCTS';
export const GET_PICKUP_PRODUCT = 'GET_PICKUP_PRODUCT';
export const GET_BOOKED_SINGLE_PICKUP = 'GET_BOOKED_SINGLE_PICKUP';
export const GET_NOT_PLANNED_SINGLE_PICKUP = 'GET_NOT_PLANNED_SINGLE_PICKUP';
export const STORE_SINGLE_PICKUP = 'STORE_SINGLE_PICKUP';
export const CLEAR_SINGLE_PICKUP = 'CLEAR_SINGLE_PICKUP';
export const GET_BOOKED_PICKUP_SHIPMENTS = 'GET_BOOKED_PICKUP_SHIPMENTS';
export const GET_NOT_PLANNED_PICKUP_SHIPMENTS = 'GET_NOT_PLANNED_PICKUP_SHIPMENTS';
export const STORE_PICKUP_SHIPMENTS = 'STORE_PICKUP_SHIPMENTS';
export const CLEAR_BOOKED_PICKUP_SHIPMENTS = 'CLEAR_BOOKED_PICKUP_SHIPMENTS';
export const CLEAR_NOT_PLANNED_PICKUP_SHIPMENTS = 'CLEAR_NOT_PLANNED_PICKUP_SHIPMENTS';
export const DOWNLOAD_PICKUP_EOD = 'DOWNLOAD_PICKUP_EOD';
export const EDIT_BOOKED_PICKUP = 'EDIT_BOOKED_PICKUP';
export const CANCEL_PICKUP = 'CANCEL_PICKUP';
export const GET_EMPTY_PICKUPS_BY_SHIPMENT = 'GET_EMPTY_PICKUPS_BY_SHIPMENT';

export const MOVE_SHIPMENTS_FROM_BOOKED_TO_NOT_PLANNED_PICKUP = 'MOVE_SHIPMENTS_FROM_BOOKED_TO_NOT_PLANNED_PICKUP';
export const REMOVE_SHIPMENTS_FROM_NOT_PLANNED_PICKUP = 'REMOVE_SHIPMENTS_FROM_NOT_PLANNED_PICKUP';
export const GET_AVAILABLE_BOOKED_PICKUPS = 'GET_AVAILABLE_BOOKED_PICKUPS';
export const MOVE_SHIPMENTS_TO_BOOKED_PICKUP = 'MOVE_SHIPMENTS_TO_BOOKED_PICKUP';

export const BOOK_PICKUP = 'BOOK_PICKUP';
export const UPDATE_PICKUP_ADDRESS = 'UPDATE_PICKUP_ADDRESS';
export const DOWNLOAD_PICKUP_POD = 'DOWNLOAD_PICKUP_POD';

/**
 * BOOKED PICKUPS
 */
export const GET_BOOKED_PICKUPS = 'GET_BOOKED_PICKUPS';
export const STORE_BOOKED_PICKUPS = 'STORE_BOOKED_PICKUPS';
export const RESET_BOOKED_PICKUPS = 'RESET_BOOKED_PICKUPS';
export const CLEAR_BOOKED_PICKUPS = 'CLEAR_BOOKED_PICKUPS';
export const DELETE_BOOKED_PICKUPS = 'DELETE_BOOKED_PICKUPS';
/**
 * NOT PLANNED PICKUPS
 */
export const GET_NOT_PLANNED_PICKUPS = 'GET_NOT_PLANNED_PICKUPS';
export const STORE_NOT_PLANNED_PICKUPS = 'STORE_NOT_PLANNED_PICKUPS';
export const RESET_NOT_PLANNED_PICKUPS = 'RESET_NOT_PLANNED_PICKUPS';
export const CLEAR_NOT_PLANNED_PICKUPS = 'CLEAR_NOT_PLANNED_PICKUPS';
export const DELETE_NOT_PLANNED_PICKUPS = 'DELETE_NOT_PLANNED_PICKUPS';

/**
 * SHIPPING METHODS
 */
export const GET_SHIPPING_METHODS = 'GET_SHIPPING_METHODS';
export const SET_SHIPPING_METHOD = 'SET_SHIPPING_METHOD';
export const EDIT_SHIPPING_METHOD = 'EDIT_SHIPPING_METHOD';
export const STORE_SHIPPING_METHODS = 'STORE_SHIPPING_METHODS';

/**
 * TEMPLATES
 */
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const GET_TEMPLATES = 'GET_TEMPLATES';
export const GET_TEMPLATE_BY_ID = 'GET_TEMPLATE_BY_ID';
export const UPDATE_EXISTING_TEMPLATE = 'UPDATE_EXISTING_TEMPLATE';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const EDIT_TEMPLATE = 'EDIT_TEMPLATE';
export const DELETE_TEMPLATE_BY_ID = 'DELETE_TEMPLATE_BY_ID';
export const STORE_TEMPLATES = 'STORE_TEMPLATES';
export const UPLOAD_TEMPLATE = 'UPLOAD_TEMPLATE';
export const STORE_UPLOAD_PROGRESS = 'STORE_UPLOAD_PROGRESS';
export const TRACK_VALIDATION_PROGRESS = 'TRACK_VALIDATION_PROGRESS';
export const TRACK_IMPORT_PROGRESS = 'TRACK_IMPORT_PROGRESS';
export const VALIDATE_ERRORS = 'VALIDATE_ERRORS';
export const START_TEMPLATE_IMPORT = 'START_TEMPLATE_IMPORT';
export const STORE_IN_QUEUE = 'STORE_IN_QUEUE';
export const UPDATE_IN_QUEUE = 'UPDATE_IN_QUEUE';
export const REMOVE_FROM_QUEUE = 'REMOVE_FROM_QUEUE';
export const STORE_ID_QUEUE = 'STORE_ID_QUEUE';

/**
 * FTP
 */
export const STORE_FTP_SETTINGS = 'STORE_FTP_SETTINGS';
export const GET_FTP_SETTINGS = 'GET_FTP_SETTINGS';
export const GET_FTP_SETTING_BY_ID = 'GET_FTP_SETTING_BY_ID';

/**
 * AI MAPPING
 */
export const AI_SUGGEST_MAPPING = 'AI_SUGGEST_MAPPING';

/**
 * DYNAMIC TEMPLATE FIELDS
 */
export const GET_DYNAMIC_TEMPLATE_FIELDS = 'GET_DYNAMIC_TEMPLATE_FIELDS';

/**
 * SYSTEM
 */
export const GET_SYSTEMS = 'GET_SYSTEMS';
export const SET_SYSTEM = 'SET_SYSTEM';
export const STORE_SYSTEM = 'STORE_SYSTEM';
export const EDIT_SYSTEM = 'EDIT_SYSTEM';

/**
 * CARRIER-ACCOUNTS
 */
export const GET_CARRIER_ACCOUNTS = 'GET_CARRIER_ACCOUNTS';
export const GET_CARRIER_ACCOUNTS_BY_COMPANY = 'GET_CARRIER_ACCOUNTS_BY_COMPANY';
export const GET_CARRIER_ACCOUNT = 'GET_CARRIER_ACCOUNT';
export const SET_CARRIER_ACCOUNT = 'SET_CARRIER_ACCOUNT';
export const STORE_CARRIER_ACCOUNTS = 'STORE_CARRIER_ACCOUNTS';
export const STORE_CARRIER_ACCOUNT = 'STORE_CARRIER_ACCOUNT';
export const EDIT_CARRIER_ACCOUNT = 'EDIT_CARRIER_ACCOUNT';
export const DELETE_CARRIER_ACCOUNT_BY_ID = 'DELETE_CARRIER_ACCOUNT_BY_ID';

export const GET_SHIPPING_AGENTS = 'GET_SHIPPING_AGENTS';
export const STORE_SHIPPING_AGENTS = 'STORE_SHIPPING_AGENTS';
export const GET_COMPANY_AVAILABLE_SHIPPING_AGENTS = 'GET_COMPANY_AVAILABLE_SHIPPING_AGENTS';
export const STORE_COMPANY_AVAILABLE_SHIPPING_AGENTS = 'STORE_COMPANY_AVAILABLE_SHIPPING_AGENTS';
export const GET_COMPANY_AVAILABLE_SHIPPING_PRODUCTS = 'GET_COMPANY_AVAILABLE_SHIPPING_PRODUCTS';
export const STORE_COMPANY_AVAILABLE_SHIPPING_PRODUCTS = 'STORE_COMPANY_AVAILABLE_SHIPPING_PRODUCTS';
export const GET_INTEGRATION_BY_CARRIER = 'GET_INTEGRATION_BY_CARRIER';
export const STORE_INTEGRATION_BY_CARRIER = 'STORE_INTEGRATION_BY_CARRIER';
export const GET_INTEGRATION_PARAMS = 'GET_INTEGRATION_PARAMS';
export const STORE_INTEGRATION_PARAMS = 'STORE_INTEGRATION_PARAMS';
export const CLEAR_INTEGRATION_PARAMS = 'CLEAR_INTEGRATION_PARAMS';

export const GET_CARRIER_ACCOUNT_PRODUCTS = 'GET_CARRIER_ACCOUNT_PRODUCTS';
export const GET_CARRIER_ACCOUNT_PRODUCT_BY_ID = 'GET_CARRIER_ACCOUNT_PRODUCT_BY_ID';
export const SET_CARRIER_ACCOUNT_PRODUCTS = 'SET_CARRIER_ACCOUNT_PRODUCTS';
export const EDIT_CARRIER_ACCOUNT_PRODUCTS = 'EDIT_CARRIER_ACCOUNT_PRODUCTS';
export const DELETE_CARRIER_ACCOUNT_PRODUCTS = 'DELETE_CARRIER_ACCOUNT_PRODUCTS';
export const STORE_CARRIER_ACCOUNT_PRODUCTS = 'STORE_CARRIER_ACCOUNT_PRODUCTS';

export const GET_SHIPPING_PRODUCTS = 'GET_SHIPPING_PRODUCTS';

/**
 * NOTIFICATIONS
 */
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const STORE_NOTIFICATIONS = 'STORE_NOTIFICATIONS';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const STORE_NOTIFICATION = 'STORE_NOTIFICATION';
export const EDIT_NOTIFICATION = 'EDIT_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

/**
 * AUTOMATIONS
 */
export const GET_AUTOMATIONS = 'GET_AUTOMATIONS';
export const STORE_AUTOMATIONS = 'STORE_AUTOMATIONS';
export const SET_AUTOMATION = 'SET_AUTOMATION';
export const GET_AUTOMATION = 'GET_AUTOMATION';
export const STORE_AUTOMATION = 'STORE_AUTOMATION';
export const EDIT_AUTOMATION = 'EDIT_AUTOMATION';
export const DELETE_AUTOMATION = 'DELETE_AUTOMATION';
export const CLEAR_AUTOMATION = 'CLEAR_AUTOMATION';
export const GET_AUTOMATION_ACTIONS = 'GET_AUTOMATION_ACTIONS';
export const STORE_AUTOMATION_ACTIONS = 'STORE_AUTOMATION_ACTIONS';
export const CLEAR_AUTOMATION_ACTIONS = 'CLEAR_AUTOMATION_ACTIONS';
export const CREATE_AUTOMATION_ACTION = 'CREATE_AUTOMATION_ACTION';
export const EDIT_AUTOMATION_ACTION = 'EDIT_AUTOMATION_ACTION';
export const DELETE_AUTOMATION_ACTIONS = 'DELETE_AUTOMATION_ACTIONS';
export const GET_ALL_PACKAGING_OPTIONS = 'GET_ALL_PACKAGING_OPTIONS';
export const STORE_ALL_PACKAGING_OPTIONS = 'STORE_ALL_PACKAGING_OPTIONS';
export const GET_ALL_AVAILABLE_SERVICE_FOR_SHIPPING_PRODUCT = 'GET_ALL_AVAILABLE_SERVICE_FOR_SHIPPING_PRODUCT'

/**
 * PALLETE, PACKAGINGS
 */
export const GET_PALLETE_TYPES = 'GET_PALLETE_TYPES';
export const STORE_PALLETE_TYPES = 'STORE_PALLETE_TYPES';
export const GET_PARCEL_TYPES = 'GET_PARCEL_TYPES';
export const STORE_PARCEL_TYPES = 'STORE_PARCEL_TYPES';
export const CLEAR_PARCEL_TYPES = 'CLEAR_PARCEL_TYPES';
export const GET_DANGEROUS_GOODS = 'GET_DANGEROUS_GOODS';
export const STORE_DANGEROUS_GOODS = 'STORE_DANGEROUS_GOODS';
export const STORE_UN_CODES = 'STORE_UN_CODES';
export const STORE_HAZARDS = 'STORE_HAZARDS';

/**
 * ACCOUNT CONSIGNOR
 */
export const GET_ACCOUNT_CONSIGNORS = 'GET_ACCOUNT_CONSIGNORS';
export const STORE_ACCOUNT_CONSIGNORS = 'STORE_ACCOUNT_CONSIGNORS';
export const SET_ACCOUNT_CONSIGNOR = 'SET_ACCOUNT_CONSIGNOR';
export const GET_ACCOUNT_CONSIGNOR = 'GET_ACCOUNT_CONSIGNOR';
export const STORE_ACCOUNT_CONSIGNOR = 'STORE_ACCOUNT_CONSIGNOR';
export const EDIT_ACCOUNT_CONSIGNOR = 'EDIT_ACCOUNT_CONSIGNOR';
export const DELETE_ACCOUNT_CONSIGNOR = 'DELETE_ACCOUNT_CONSIGNOR';

/**
 * ACCOUNT DANSKE CODE
 */
export const GET_ACCOUNT_DANSKE_CODES = 'GET_ACCOUNT_DANSKE_CODES';
export const STORE_ACCOUNT_DANSKE_CODES = 'STORE_ACCOUNT_DANSKE_CODES';
export const GET_ACCOUNT_DANSKE_CODE = 'GET_ACCOUNT_DANSKE_CODE';
export const SET_ACCOUNT_DANSKE_CODE = 'SET_ACCOUNT_DANSKE_CODE';
export const EDIT_ACCOUNT_DANSKE_CODE = 'EDIT_ACCOUNT_DANSKE_CODE';
export const GET_ACCOUNT_DANSKE_CONFIGURATIONS = 'GET_ACCOUNT_DANSKE_CONFIGURATIONS';

/**
 * REPORTS
 */
export const GET_REPORTS = 'GET_REPORTS';
export const STORE_REPORTS = 'STORE_REPORTS';
export const CLEAR_REPORTS = 'CLEAR_REPORTS';
export const ADD_REPORT = 'ADD_REPORT';
export const DELETE_REPORTS = 'DELETE_REPORTS';
export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT';

/**
 * INVOICES
 */
export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICE = 'GET_INVOICE';
export const STORE_INVOICES = 'STORE_INVOICES';
export const STORE_INVOICE = 'STORE_INVOICE';
export const CLEAR_INVOICES = 'CLEAR_INVOICES';
export const CLEAR_INVOICE = 'CLEAR_INVOICE';

export const GET_INVOICE_ITEMS = 'GET_INVOICE_ITEMS';
export const STORE_INVOICE_ITEMS = 'STORE_INVOICE_ITEMS';
export const CLEAR_INVOICE_ITEMS = 'CLEAR_INVOICE_ITEMS';

export const DOWNLOAD_VENDOR_INVOICE = 'DOWNLOAD_VENDOR_INVOICE'

/**
 * ITEMS
 */
export const GET_ITEMS = 'GET_ITEMS';
export const STORE_ITEMS = 'STORE_ITEMS';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const ADD_ITEM = 'ADD_ITEM';
export const DELETE_ITEMS = 'DELETE_ITEMS';
export const SET_ITEM = 'SET_ITEM';
export const STORE_ITEM = 'STORE_ITEM';
export const EDIT_ITEM = 'EDIT_ITEM';
export const GET_ITEM = 'GET_ITEM';
export const UPLOAD_ITEM_IMAGE = 'UPLOAD_ITEM_IMAGE';

/**
 * NOTIFICATIONS
 */
export const GET_INTERNAL_NOTIFICATIONS = 'GET_INTERNAL_NOTIFICATIONS';
export const GET_UNREAD_INTERNAL_NOTIFICATIONS = 'GET_UNREAD_INTERNAL_NOTIFICATIONS';
export const CLEAR_INTERNAL_NOTIFICATIONS = 'CLEAR_INTERNAL_NOTIFICATIONS';
export const STORE_INTERNAL_NOTIFICATIONS = 'STORE_INTERNAL_NOTIFICATIONS';
export const MARK_INTERNAL_NOTIFICATIONS_SEEN = 'MARK_INTERNAL_NOTIFICATIONS_SEEN';
export const RESET_NOTIFICATION_COUNT = 'RESET_NOTIFICATION_COUNT';
